import axios from "axios";

const BASE_API_URL = "/api/auth";

class AuthService {
  //登出：fire-and-forget 呼叫後端清 httpOnly cookie，本地立即清掉 user / login_status
  logout() {
    axios.post(BASE_API_URL + "/logout").catch(() => {}); //後端清不掉也沒關係，本地一定會清
    localStorage.removeItem("user");
    localStorage.setItem("login_status", false);
  }

  //登入：token 由後端設成 httpOnly cookie，前端只需要存 profile 給 UI 顯示用
  //  廣播 user-updated → 讓已 mount 的 nav / 其他元件同步刷新登入狀態
  login(profile) {
    localStorage.setItem("user", JSON.stringify(profile));
    localStorage.setItem("login_status", "true");
    window.dispatchEvent(new CustomEvent("user-updated", { detail: profile }));
  }

  //更新本地 profile 並廣播 user-updated 事件（讓 nav 等已 mount 的元件能同步刷新）
  updateUserInfo(profile) {
    localStorage.setItem("user", JSON.stringify(profile));
    window.dispatchEvent(new CustomEvent("user-updated", { detail: profile }));
  }

  getLoginStatus() {
    return localStorage.getItem("login_status") == "true";
  }

  getUserProfile() {
    return JSON.parse(localStorage.getItem("user"));
  }

  //Firebase Auth 統一登入：client 拿 Firebase ID Token，後端 verifyIdToken
  //  支援 Google / Apple / Email 任何 Firebase provider
  //  options:
  //    deviceToken — 單一 string（這台裝置目前的推播 token）；Web 預設 ""
  //                 後端會比對 user.deviceTokens 陣列，沒重複才加入
  //    osType     — "0" Web / "1" iOS / "2" Android；Web 預設 "0"
  //  → Web 呼叫 firebaseLogin(idToken) → 自動帶 "", "0"
  //  → App 呼叫 firebaseLogin(idToken, { deviceToken: "fcm_xxx", osType: "1" })
  firebaseLogin(idToken, { deviceToken = "", osType = "0" } = {}) {
    return axios.post(BASE_API_URL + "/firebase-login", {
      idToken,
      deviceToken,
      osType,
    });
  }

  //使用者註冊
  register(profile) {
    const {
      name,
      gender,
      birthDate,
      timeMode,
      birthTimeSign,
      birthClockTime,
      birthLongitude,
      birthLatitude,
    } = profile;

    return axios.post(BASE_API_URL + "/register-full", {
      name,
      gender,
      birthDate,
      timeMode,
      birthTimeSign,
      birthClockTime,
      birthLongitude,
      birthLatitude,
    });
  }

  //公開刪除帳號（不需登入；用 email 或 userID 二選一；Google 審核規範）
  //  payload: { userEmail? , userID? }
  //  回傳 data.resultCode: "1" 成功 / "-1" 找不到用戶
  deleteAccountPublic({ userEmail, userID }) {
    return axios.post(BASE_API_URL + "/delete-account-email", {
      userEmail,
      userID,
    });
  }
}

export default new AuthService();
